import { ACCESS_TYPE, DAY_FULL_TO_ABBR, PERIOD_ACCESS_TYPE } from 'components/UI/DynamicAlertRows/constants';
import { parse } from 'date-fns';
import { generateAlertText } from 'utils/alertHelpers';
import { ALERT_TYPES } from 'utils/constants';
import { DEFAULT_START_TIME, generateDefaultTimeRestrictions } from 'utils/dateTimeHelpers';
const { timeRestrictions: defaultTimeRestrictions, start, end } = generateDefaultTimeRestrictions();

export const transformAuthorizedPersons = (data) => {
    return Object.values(
        data.reduce((obj, el) => {
            const modifiedAuthorizedPerson = {
                ...el,
                id: el.authorizedPerson.id,
                timestamp: `${el.created.slice(0, 10)} ${el.created.slice(11, 16)}`,
                firstName: el.authorizedPerson.firstName,
                lastName: el.authorizedPerson.lastName,
                position: el.authorizedPerson.position,
                phoneNumber: el.authorizedPerson.phoneNumber,
                dl: el.authorizedPerson.dl,
                cdl: el.authorizedPerson.cdl,
                companyCardNumber: el.authorizedPerson.companyCardNumber,
                idCountry: el.authorizedPerson.idCountry,
                alerts: !!el.authType?.color,
                authorizedBy: '',
                authorizedByInfo: el.authorizedBy,
                note: el.note || '',
                authTypes: [],
                organization: el.authorizedPerson.organization,
                dateOfBirth: el.authorizedPerson.dateOfBirth,
                fullName: `${el.authorizedPerson?.firstName} ${el.authorizedPerson?.lastName}`,
            };

            const updatedAuthType = {
                ...modifiedAuthorizedPerson.authType,
                authTypeId: el.id,
                authorizedBy: modifiedAuthorizedPerson.authorizedByInfo,
                note: modifiedAuthorizedPerson.note,
                modified: modifiedAuthorizedPerson.modified,
                limitedPeriodAccess: {
                    accessType: el.accessType,
                    startTime: el.startTime,
                    endTime: el.endTime,
                    weekdays: el.weekdays,
                    periodType: el.periodType,
                },
            };

            modifiedAuthorizedPerson.authType = updatedAuthType;
            modifiedAuthorizedPerson.authTypes = [updatedAuthType];

            if (obj[modifiedAuthorizedPerson.id]) {
                obj[modifiedAuthorizedPerson.id].authTypes = [...obj[modifiedAuthorizedPerson.id].authTypes, updatedAuthType];
            } else {
                obj[modifiedAuthorizedPerson.id] = { ...modifiedAuthorizedPerson };
            }

            obj[modifiedAuthorizedPerson.id]?.authTypes.sort((a, b) => (a.name === ALERT_TYPES.BANNED ? -1 : b.name === ALERT_TYPES.BANNED ? 1 : 0));

            obj[modifiedAuthorizedPerson.id].alert = generateAlertText(obj[modifiedAuthorizedPerson.id].authTypes);

            return obj;
        }, {})
    );
};

export const mapInitialAlertRows = (selectedOrganization) => {
    return (
        selectedOrganization?.authTypes?.map((authType, index) => {
            const { limitedPeriodAccess } = authType;
            const isLimitedAccess = limitedPeriodAccess?.periodType === PERIOD_ACCESS_TYPE.LIMIT;
            const timeRestrictions = (limitedPeriodAccess?.weekdays || []).reduce(
                (acc, day) => {
                    const mappedDay = DAY_FULL_TO_ABBR[day.day];
                    acc[mappedDay] = {
                        start: day.timeRanges?.[0]?.startTime ? parse(day.timeRanges[0].startTime, 'HH:mm', new Date()) : start,
                        end: day.timeRanges?.[0]?.endTime ? parse(day.timeRanges[0].endTime, 'HH:mm', new Date()) : end,
                        checked: !!day.timeRanges?.length,
                    };
                    return acc;
                },
                { ...defaultTimeRestrictions }
            );

            return {
                id: `row-${index}`,
                authType: { id: authType.id },
                authorizedBy: { id: authType.authorizedBy?.id },
                note: authType.note || '',
                isPeriodAccessVisible: false,
                accessType: limitedPeriodAccess?.accessType || ACCESS_TYPE.PERMANENT,
                limitedAccess: isLimitedAccess,
                startTime: limitedPeriodAccess?.startTime ? new Date(limitedPeriodAccess?.startTime) : DEFAULT_START_TIME,
                endTime: limitedPeriodAccess?.endTime ? new Date(limitedPeriodAccess?.endTime) : null,
                timeRestrictions,
            };
        }) || []
    );
};

export const createPeopleFormPayload = (values, type) => {
    return {
        clientPersonnel: {
            dateOfBirth: values.dateOfBirth,
            firstName: values.firstName,
            lastName: values.lastName,
            position: values.position,
            phoneNumber: values.phoneNumber,
            dl: values.dl,
            cdl: values.cdl,
            companyCardNumber: values.companyCardNumber,
            idCountry: values.idCountry,
            organization: {
                id: values.organization?.id ?? values.organization,
            },
        },
        location: {
            id: type.locationId,
        },
        monitoringObjectIds: values.accessPoints.map((item) => item.id),
        authorizationTypes: type.authorizationTypes,
    };
};

export const updatePeopleFormPayload = (values, type, authOrgId) => {
    const data = createPeopleFormPayload(values, type);
    return (data.authorizationTypes || []).map((item) => {
        return {
            id: authOrgId,
            ...item,
            ...{
                id: item.id,
                authorizedPerson: { id: authOrgId },
                location: data.location,
                monitoringObjectIds: data.monitoringObjectIds,
            },
        };
    });
};
